import axios from "axios";
import { create } from "zustand";

export const useLangsState = create((set, get) => ({
    langs: [],
    columns: [
        {
            title: "ID",
            dataIndex: "id",
            key: "id",
            width: 50,
        },
        {
            title: "Nomi",
            dataIndex: "til",
            key: "til",
        },
    ],
    ed: {},
    setEd: (ed) => set({ ed }),

    getNashr: () => {
        axios.get("/til")
            .then(({ data }) => {
                set({ langs: data });
            })
            .catch((err) => {
                console.error('Tillarni yuklab olishda xatolik:', err);
                set({ langs: [] });
            })
    },
    addNashr: (data) => {
        axios.post("/til", data)
            .then(() => get().getNashr())
            .catch((err) => {
                console.error('Til qo\'shishda xatolik:', err);
            })
    },
    editNashr: (data) => {
        axios.put(`/til/${data.id}`, data)
            .then(() => get().getNashr())
            .catch((err) => {
                console.error('Tilni taxrirlashda xatolik:', err);
            })
    },
    deleteNashr: (_, id) => {
        axios.delete(`/til/${id.id}`)
            .then(() => get().getNashr())
            .catch((err) => {
                console.error('Tilni o\'chirishda xatolik:', err);
            })
    },
}));